import { PlayersSortByType } from "../../../components/organisms/PlayersToolbar/PlayersToolbar";
import { MetaRatingsPlayer } from "../../../redux/players/playersSlice";
import axios from "../../apiFc24";

const queryParamDict = {
  countries: "country",
  leagues: "league",
  clubs: "club",
  skillMoves: "skill-moves",
  weakFoot: "weak-foot",
  positions: "position",
  rarities: "rarity",
} as const;

type BackendMetaRatingsPlayer = MetaRatingsPlayer & {
  positions: string[];
  isSbc: boolean;
  isObjective: boolean;
};

export const getPlayers = async ({
  page,
  sort,
  myClub,
  myEvolvedPlayers,
  chainedEvo,
  excludePaidEvo,
  excludeCompletedEvolutions,
  playerRoleId,
  queryParams,
  evolutions,
  evoIds,
  searchText,
}: {
  page: number;
  sort: PlayersSortByType;
  myClub?: boolean;
  myEvolvedPlayers?: boolean;
  chainedEvo?: boolean;
  excludePaidEvo?: boolean;
  excludeCompletedEvolutions?: boolean;
  playerRoleId?: number;
  queryParams?: any;
  evolutions?: boolean;
  evoIds?: number[];
  searchText?: string;
}): Promise<{
  players: MetaRatingsPlayer[];
  totalPages: number;
}> => {
  const params: string[] = [];

  // Add page parameter
  params.push(`page=${page}`);

  // Add sort parameter without value
  params.push(`sort-${sort}`);

  // Add boolean parameters without values
  if (myClub) params.push("my-club");
  if (myEvolvedPlayers) params.push("my-evolved");
  if (chainedEvo) params.push("chained");
  if (excludePaidEvo) params.push("excludePaid");
  if (excludeCompletedEvolutions) params.push("excludeCompleted");

  // Add parameters with values
  if (playerRoleId) params.push(`player-role-id=${playerRoleId}`);
  if (evoIds?.length) params.push(`evolution=${evoIds.join(",")}`);
  if (searchText) params.push(`search=${searchText}`);

  queryParams?.forEach((element) => {
    const elementAsObject = Object.entries(element);
    const key = elementAsObject[0][0];
    const values = elementAsObject[0][1] as number[];
    if (values.length > 0) {
      params.push(`${queryParamDict[key] || key}=${values.join(",")}`);
    }
  });

  const queryString = params.join("&");

  const res = await axios.get<{
    players: BackendMetaRatingsPlayer[];
    totalPages: number;
  }>(`/players${evolutions ? "/evolutions" : ""}?${queryString}`);

  const { players, totalPages } = res.data;

  const playersRes = players.map((player) => ({
    ...player,
    positions: Array.from(
      new Set([player.preferredPosition, ...player.possiblePositions]),
    ),
    isSbcPlayer: player.isSbc,
    isObjectivePlayer: player.isObjective,
  }));

  return { players: playersRes, totalPages };
};
